import React from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const WHATSAPP_NUMBER = '+918492833393'; 
const PHONE_NUMBER = '+919469530962'; 

const PackageDetails = ({ destinations }) => {
  const { title } = useParams();

  const packageDetails = destinations
    .flatMap(dest => dest.packages)
    .find(pkg => pkg.title === decodeURIComponent(title));

  if (!packageDetails) {
    return <h2 className="text-xl font-semibold text-red-600">Package not found.</h2>;
  }

  return (
    <div className="mt-3">
      <Helmet>
        <title>{packageDetails.title}</title>
      </Helmet>
      <div className="max-w-2xl mx-auto rounded-lg shadow-lg overflow-hidden">
        <img
          className="w-full h-[300px] object-cover"
          src={packageDetails.image}
          alt={packageDetails.title}
        />
        <div className="p-6">
          <h1 className="text-2xl font-bold text-orange-600 mb-3">
            {packageDetails.title}
          </h1>
          <p className="text-lg text-green-600 mb-3">
            {packageDetails.summary}
          </p>
          <div className="flex items-center justify-between mb-3">
            <p className="text-xl text-amber-600">
              <strong>Price:</strong>
              {packageDetails.price.split('\n')
               .map(e =><p className='mb-1'>{e}</p>)}
            </p>
            <div className="flex items-center space-x-4">
              {/* WhatsApp Icon */}
              <a
                href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hello,%20I%20am%20interested%20in:%20${encodeURIComponent(packageDetails.title)}%20package`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-500 hover:text-green-700"
                title="Chat on WhatsApp"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.52 3.48A11.93 11.93 0 0012 0C5.37 0 0 5.37 0 12c0 2.11.55 4.16 1.6 5.97L0 24l6.18-1.62A11.94 11.94 0 0012 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.19-3.48-8.52zM12 22c-1.85 0-3.66-.5-5.23-1.45l-.37-.22-3.67.96.98-3.58-.24-.37A9.94 9.94 0 012 12c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10zm5.2-7.8c-.28-.14-1.65-.81-1.9-.9-.25-.09-.43-.14-.61.14-.18.28-.7.9-.86 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.44-2.25-1.4-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.34.42-.51.14-.17.18-.29.28-.48.09-.19.05-.36-.02-.5-.07-.14-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47-.16-.01-.35-.01-.54-.01-.19 0-.5.07-.76.34-.26.27-1 1-.97 2.43.03 1.43 1.03 2.81 1.18 3.01.15.2 2.03 3.1 4.93 4.23.69.3 1.23.48 1.65.61.69.22 1.32.19 1.81.12.55-.08 1.65-.67 1.88-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.53-.33z"/>
                </svg>
              </a>
              {/* Phone Icon */}
              <a
                href={`tel:${PHONE_NUMBER}`}
                className="text-green-500 hover:text-green-700"
                title="Call Us"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M7 2C5.895 2 5 2.895 5 4v16c0 1.105.895 2 2 2h10c1.105 0 2-.895 2-2V4c0-1.105-.895-2-2-2H7zm0 2h10v16H7V4zm5 15a1 1 0 110-2 1 1 0 010 2z"/>
                </svg>
              </a>
            </div>
          </div>
          <p className="text-sm text-gray-600 mb-3">
            <p className='text-lg text-green-600'>Inclusions:</p>{packageDetails.Inclusion}
          </p>
          <p className="text-sm text-grey-600 mb-3">
            <p className='text-lg text-green-600'>Exclusions:</p> {packageDetails.exclusion}
          </p>
          <p className="text-sm text-gray-600 mb-4">
            <p className='text-lg text-green-600'>Itinerary:</p>
            {packageDetails.itinerary.split('\n')
               .map(e =><p className='mb-1'>{e}</p>)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PackageDetails;